import React from 'react';
import { CountryClicks } from '../../../../types/interfaces';

interface RowProps {
  data: CountryClicks;
  flag?: string;
  minClicks: number;
  maxClicks: number;
}

const RowChart: React.FC<RowProps> = ({ data, flag, minClicks, maxClicks }) => {
  const percent = maxClicks > 0 ? (data.clicks / maxClicks) * 100 : 0;
  const widthPercentage = `${percent}%`;

  const formatClicks = (clicks: number) => {
    return clicks >= 1000
      ? `${(clicks / 1000).toFixed(1)}K`
      : clicks.toString();
  };

  const colorScale = (clicks: number) => {
    if (clicks === 0) return '#f0f0f0';

    const logClicks = Math.log10(clicks);
    const logMinClicks = Math.log10(minClicks);
    const logMaxClicks = Math.log10(maxClicks);
    const ratio = (logClicks - logMinClicks) / (logMaxClicks - logMinClicks);

    if (ratio >= 0.8) return 'bg-[#30009C]';
    if (ratio >= 0.6) return 'bg-[#5000B9]';
    if (ratio >= 0.4) return 'bg-[#7700D6]';
    if (ratio >= 0.2) return 'bg-[#AB4DE9]';
    return 'bg-[#ECD8FD]';
  };

  return (
    <div className="flex items-center w-full min-h-[20px] pr-[50px]">
      <div className="flex items-center w-24 flex-shrink-0">
        <div className="flex items-center gap-1 w-full overflow-hidden">
          {flag && (
            <img
              src={flag}
              alt={data.country}
              className="w-5 h-5 flex-shrink-0"
            />
          )}
          <span
            className="text-sm text-[#9B919D] truncate"
            title={data.country}
          >
            {data.country}
          </span>
        </div>
      </div>

      {/* Bar chart container */}
      <div className="relative flex-1 h-4 mx-4">
        {/* Background track */}
        <div className="absolute h-full bg-white opacity-0 rounded-full w-full" />

        {/* Colored progress bar with text */}
        <div className="relative h-full w-full">
          <div
            className={`absolute h-full rounded-full transition-all duration-300 ease-out ${colorScale(data.clicks)}`}
            style={{ width: widthPercentage }}
          />
          <div
            className="absolute top-0 h-full flex items-center"
            style={{ left: widthPercentage }}
          >
            <span className="text-sm text-[#9B919D] ml-2">
              {formatClicks(data.clicks)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowChart;
